module.exports = __webpack_public_path__ + "media/images/home/main/aa/10-7d6f4fe34f3aab79b0805a3a042e8da3.png";